import { useEffect, useState } from "react";
import PortfolioList from "../portfolioList/PortfolioList";
import "./portfolio.scss"
import { RollUp, posters, brochures, bookjournalcover, certificate, others } from "../../data"
import Pagination from "../pagination/Pagination";

function Portfolio() {

    const [selected, setSelected] = useState("featured")
    const [data, setData] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [postsPerPage, setPostsPerPage] = useState(8)

    const list = [
        {
            id: "featured",
            title: "Roll Up",
        },
        {
            id: "posters",
            title: "Posters",
        },
        {
            id: "brochures",
            title: "Brochures",
        },
        {
            id: "book/journal cover",
            title: "Book/Journal Cover",
        },
        {
            id: "certificate",
            title: "Certificate",
        },
        {
            id: "others",
            title: "Others",
        },
    ]

    useEffect(() => {
        setCurrentPage(1)
        switch (selected) {
            case "Roll Up":
                setData(RollUp)
                break;
            case "posters":
                setData(posters)
                break;
            case "brochures":
                setData(brochures)
                break;
            case "book/journal cover":
                setData(bookjournalcover)
                break;
            case "certificate":
                setData(certificate)
                break;
            case "others":
                setData(others)
                break;
            default:
                setData(RollUp)
        }
    }, [selected])

    const lastPostIndex = currentPage * postsPerPage
    const firstPostIndex = lastPostIndex - postsPerPage
    const currentPosts = data.slice(firstPostIndex, lastPostIndex)

    return (
        <div className='portfolio' id="portfolio">
            <h1>Photoshop Portfolio</h1>
            <ul>
                {list.map(item => (
                    <PortfolioList
                        key={item.id}
                        title={item.title}
                        active={selected === item.id}
                        setSelected={setSelected}
                        id={item.id} />
                ))}
            </ul>
            <div className="container">
                {currentPosts.map(d => (
                    <div className="item" >
                        <img src={d.img} alt="" />
                    </div>
                ))}
            </div>
            <Pagination totalPosts={data.length} postsPerPage={postsPerPage}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage} />
        </div>
    );
}

export default Portfolio;